import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { take } from 'rxjs/operators';

import { ApiError, MessageService } from '../../../core';

import { LocalFaturamentoFilter } from '../filter';
import { LocalFaturamentoCrudHttpService } from '../services';
import { localFaturamentoAtivo, isLocalFaturamentoSituacaoInativo } from '../local-faturamento-situacao';
import { LocalFaturamento } from '../local-faturamento';

@Component({
    selector: 'sgt-local-faturamento-select',
    templateUrl: './local-faturamento-select.component.html',
    styleUrls: ['./local-faturamento-select.component.less'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => LocalFaturamentoSelectComponent), multi: true },
    ]
})
export class LocalFaturamentoSelectComponent implements OnInit {
    /** ID do local de faturamento */
    @Input() ngModel: number;
    /** Ao alterar o local de faturamento */
    @Output() ngModelChange = new EventEmitter<number>();

    /** Local de faturamento */
    @Input() localFaturamento: LocalFaturamento;
    @Output() localFaturamentoChange = new EventEmitter<LocalFaturamento>();

    /** Locais de faturamentos */
    locaisFaturamentos: LocalFaturamento[] = [];

    /** Nome do input */
    @Input() name: string;
    /* ID do input */
    @Input() id: string;
    /* Se o valor é obrigatório */
    @Input() required: any;
    /* Se deve desabilitar o input */
    @Input() disabled: boolean;
    /** Se deve setar o focus automaticamente */
    @Input() autofocus = false;
    /** Se deve pesquisar os locais de faturamento ao iniciar o component */
    @Input() searchOnInit = true;
    /** Se pode selecionar nenhuma opção */
    @Input() canSelectNull = true;
    /** Label para a opção de selecionar a opção nula */
    @Input() nullLabel = 'NENHUM LOCAL DE FATURAMENTO'
    /** Se deve filtrar somente os locais de faturamentos ativos */
    @Input() somenteAtivos = false;

    @ViewChild('select') select: ElementRef;

    propagateChange: any = () => {};

    constructor(private messageService: MessageService,
                private localFaturamentoCrudHttpService: LocalFaturamentoCrudHttpService) { }

    ngOnInit() {
        if (this.searchOnInit) {
            this.search();
        }
    }


    /** Pesquisa os locais de faturamentos*/
    search(): Promise<LocalFaturamento[]> {
        return new Promise<LocalFaturamento[]>((resolve, reject) => {
            this.locaisFaturamentos = [];


            const filter = new LocalFaturamentoFilter();
            // Somente ativos
            if (this.somenteAtivos) {
                filter.situacao = localFaturamentoAtivo.id;
            }


            this.localFaturamentoCrudHttpService.searchWithFilter(filter)
                .pipe(
                    take(1)
                )
                .subscribe(
                    locaisFaturamentos => {
                        this.locaisFaturamentos = locaisFaturamentos;

                        if (this.localFaturamento) {
                            const indexLocalFaturamento = this.locaisFaturamentos?.findIndex(localFaturamentoFilter => localFaturamentoFilter.id === this.localFaturamento.id);
                            if (indexLocalFaturamento < 0) {
                                this.locaisFaturamentos.unshift(this.localFaturamento);
                            }
                        }

                        resolve(this.locaisFaturamentos);
                    },
                    (error: ApiError) => {
                        this.messageService.error(error.message, 'Erro ao pesquisar os locais de faturamentos', error);
                        reject(error);
                    }
                );
        });
    }

    /** Verifica se o local de faturamento está inativo */
    isSituacaoInativo(situacao: number): boolean {
        return isLocalFaturamentoSituacaoInativo(situacao);
    }

    /** Ao alterar o local de faturamento */
    onChange(idLocalFaturamento: number) {
        this.ngModel = idLocalFaturamento;
        this.propagateChange(this.ngModel);

        this.localFaturamento = this.locaisFaturamentos?.find(localFaturamentoFilter => localFaturamentoFilter.id === idLocalFaturamento);
        this.localFaturamentoChange.emit(this.localFaturamento);
    }

    /** Seta o focus no select */
    setFocus() {
        jQuery(this.select?.nativeElement).trigger('focus');
    }

    writeValue(value: number) {}

    registerOnChange(fn) {
        this.propagateChange = fn;
    }

    registerOnTouched() {}
}
